import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'address-card': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faVcard" */
        '@fortawesome/free-regular-svg-icons/faVcard'
    ),
    'calendar-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCalendarXmark" */
        '@fortawesome/free-regular-svg-icons/faCalendarXmark'
    ),
    'chess-bishop': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faChessBishop" */
        '@fortawesome/free-regular-svg-icons/faChessBishop'
    ),
    'circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCircle" */
        '@fortawesome/free-regular-svg-icons/faCircle'
    ),
    'circle-pause': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faPauseCircle" */
        '@fortawesome/free-regular-svg-icons/faPauseCircle'
    ),
    'commenting': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCommenting" */
        '@fortawesome/free-regular-svg-icons/faCommenting'
    ),
    'face-smile': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSmile" */
        '@fortawesome/free-regular-svg-icons/faSmile'
    ),
    'face-smile-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSmileWink" */
        '@fortawesome/free-regular-svg-icons/faSmileWink'
    ),
    'file-text': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFileText" */
        '@fortawesome/free-regular-svg-icons/faFileText'
    ),
    'gem': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGem" */
        '@fortawesome/free-regular-svg-icons/faGem'
    ),
    'hourglass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHourglassEmpty" */
        '@fortawesome/free-regular-svg-icons/faHourglassEmpty'
    ),
    'stop-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faStopCircle" */
        '@fortawesome/free-regular-svg-icons/faStopCircle'
    ),
    'vcard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faVcard" */
        '@fortawesome/free-regular-svg-icons/faVcard'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>